import { createContext } from 'react'

export type PageBlockType = {
  id: number
}

export type PageType = {
  id?: number
  title?: string
  updatedAt?: string
}

export type MeetingType = {
  id?: number
  title?: string
  meetingType?: string
  attendees?: MeetingAttendeeType[]
  organizer?: MeetingOrganizerType
}

export type MeetingOrganizerType = {
  id?: number
  avatar?: {
    id?: number
    url?: string
  }
  firstName?: string
  fullName?: string
  lastName?: string
}

export type MeetingAttendeeType = {
  id?: number
  employee?: {
    id?: number
    avatar?: {
      id?: number
      url?: string
    }
    firstName?: string
    fullName?: string
    lastName?: string
  }
}

export interface MeetingsMeetingContextState {
  notes: string | null
  setNotes: (notes: string) => void
  loading: boolean
  isSavingNotes: boolean
  error: boolean
  errorMessage: string | null
  resetError: () => void
  page: PageType | null
  meeting: MeetingType | null
}

export const MeetingsMeetingContext = createContext<MeetingsMeetingContextState | undefined>(
  undefined
)
